import { addDays } from './time';

const defaultOptions = {
	domain: `${window.location.hostname}`,
	path: '/',
	maxAge: 1000 * 60 * 60 * 24 * 30, // days
	isTestEnv: process.env.NODE_ENV === 'test',
	isLocalEnv: window.location.hostname.includes('local'), // remove once local has https
};

export const setCookie = (name, value, options = {}) => {
	const maxAge = options.maxAge || defaultOptions.maxAge;
	const domain = options.domain || defaultOptions.domain;
	const path = options.path || defaultOptions.path;
	const isTestEnv = options.isTestEnv || defaultOptions.isTestEnv;

	document.cookie = isTestEnv
		? `${name}=${value}; max-age=${maxAge}; path=${path}`
		: defaultOptions.isLocalEnv
		? `${name}=${value}; max-age=${maxAge}; domain=${domain}; path=${path}`
		: `${name}=${value}; max-age=${maxAge}; secure=true; domain=${domain}; path=${path}`;

	return value;
};

export const escapeCookieName = (str) => {
	return str.replace(/([.*+?^${}()|[\]/\\])/g, '\\$1');
};

export const matchCookieRegex = (name) => {
	return RegExp('(?:^|;\\s*)' + escapeCookieName(name) + '=([^;]*)');
};

export const getCookie = (name) => {
	let match = document.cookie.match(matchCookieRegex(name));

	if (!match) {
		return undefined;
	}

	let cookie;

	try {
		cookie = decodeURIComponent(match[1]);
	} catch (e) {
		cookie = match[1];
	}

	return cookie;
};

export const deleteCookie = (name, options = {}) => {
	const path = options.path || defaultOptions.path;
	const domain = options.domain || defaultOptions.domain;

	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.stash.com; path=${path}`;
	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${domain}; path=${path}`;
};

const SIXTY_DAYS_FROM_NOW = addDays(new Date(), 60);
const UTMS = [
	'utm_source',
	'utm_medium',
	'utm_campaign',
	'utm_content',
	'utm_term',
	'irclickid',
	'irclid',
	'gclid',
	'fbclid',
	'ttclid',
];

export const setUTMCookies = () => {
	const params = new URLSearchParams(window.location.search);
	params.forEach((value, key) => {
		if (UTMS.includes(key)) {
			document.cookie = `${key}=${value}; expires=${SIXTY_DAYS_FROM_NOW.toUTCString()}; secure=true; domain=.stash.com; path=/`;
		}
	});
};

export const getUTMCookies = () => {
	const utmCookiesString = UTMS.reduce((acc, utm) => {
		if (getCookie(utm)) {
			acc += `&${utm}=${getCookie(utm)}`;
		}
		return acc;
	}, '');
	return utmCookiesString;
};
